import { useTranslation } from 'react-i18next';
import { NavigationPill } from '@/components/home';
import { PageHeader, PageShell } from '@/components/layout';

const PRIVACY_EMAIL = 'customerservice@clearlab.com';

export default function Privacy() {
  const { t } = useTranslation();
  const paragraphs = t('privacy.paragraphs', { returnObjects: true }) as string[];
  const backToHomeLink = [{ label: t('notFound.backToHome'), to: '/' }] as const;
  return (
    <PageShell
      title={t('privacy.meta.title')}
      description={t('privacy.meta.description')}
      path="/legal/privacy"
      hideHeader
    >
      <NavigationPill />
      <PageHeader title={t('privacy.pageHeader')} links={backToHomeLink} />

      <section
        aria-labelledby="privacy-heading"
        className="bg-clearlab-oat px-6 py-30 md:px-14 lg:px-20 lg:py-50 xl:px-30"
      >
        <div className="mx-auto flex w-full max-w-content-xl flex-col gap-30">
          <div className="flex w-full flex-col gap-10 md:flex-row md:items-start md:justify-between">
            <h2
              id="privacy-heading"
              className="text-[32px] font-normal leading-8 tracking-[-0.025em] text-clearlab-dusk md:min-w-[240px] md:max-w-[440px] md:flex-1 xl:w-[440px] xl:flex-none"
            >
              {t('privacy.sectionTitle')}
            </h2>

            <div className="flex w-full flex-col md:w-[600px]">
              <p className="mb-10 w-full text-[16px] font-semibold leading-[44px] text-clearlab-midnight">
                {t('privacy.companyName')}
              </p>
              {paragraphs.map((paragraph, i) => (
                <p
                  key={i}
                  className="mb-10 w-full text-[16px] font-normal leading-[44px] text-clearlab-midnight"
                >
                  {paragraph}
                </p>
              ))}
              <p className="w-full text-[16px] font-normal leading-[44px] text-clearlab-midnight">
                {t('privacy.finalParagraph.pre')}
                <a
                  href={`mailto:${PRIVACY_EMAIL}`}
                  className="underline transition-colors duration-fast ease-smooth hover:text-clearlab-blue"
                >
                  {PRIVACY_EMAIL}
                </a>
                {t('privacy.finalParagraph.post')}
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col items-start gap-6">
            <hr className="w-full border-0 border-t-[0.7px] border-clearlab-divider-darker" />
            <p className="w-full text-[12px] font-normal leading-[14px] text-clearlab-steel">
              {t('privacy.disclaimer.pre')}
              <a
                href={`mailto:${PRIVACY_EMAIL}`}
                className="underline transition-colors duration-fast ease-smooth hover:text-clearlab-blue"
              >
                {PRIVACY_EMAIL}
              </a>
              {t('privacy.disclaimer.post')}
            </p>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
